import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OnboardingEventConfigAddPageUI from './OnboardingEventConfigAddPageUI'

class OnboardingEventConfigAddPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            eventDetails: {
                eventCode: '',
                eventName: '',
                whatsappTemplateName: '',
                messageBodyText: '',
                coolOffPeriodMin: 0,
                whatsappFrequencyDays: 0,
                emailFrequencyDays: 0,
                maxWhatsappCount: 0,
                maxEmailCount: 0,
                escalationRequired: false,
                escalationAfterReminders: 0,
                escalationEmail: '',
                isActive: true
            },
            loading: false, // No initial fetch needed
            errorList: null,
            submitting: false,
            submitError: null,
            errors: {},
            isFormValid: false
        }
    }

    componentDidMount() {
        Modal.setAppElement('body')
        this.validateForm(this.state.eventDetails)
    }

    validateField = (field, value, formState) => {
        let errors = { ...this.state.errors }
        let error = ''

        switch (field) {
            case 'eventName':
                if (!value || value.length < 5) error = 'Minimum 5 characters required'
                break
            case 'whatsappTemplateName':
                if (formState.eventCode !== 'PAN_AWAITED') {
                    if (!value || value.length < 5) error = 'Minimum 5 characters required'
                }
                break
            case 'eventCode':
                if (!value) error = 'Required'
                break
            case 'messageBodyText':
                const isSpecialEventMsg = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventMsg) {
                    if (!value || value.length < 5) error = 'Minimum 5 characters required'
                }
                break
            case 'whatsappFrequencyDays':
            case 'maxWhatsappCount':
                const isSpecialEventOrPan = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED' || formState.eventCode === 'PAN_AWAITED';
                if (!isSpecialEventOrPan) {
                    // Check if it's a valid integer
                    if (value === '' || value === null) {
                        // Optional ? If required add error
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            case 'emailFrequencyDays':
            case 'maxEmailCount':
            case 'escalationAfterReminders':
            case 'coolOffPeriodMin':
                // For WAITING_SCREEN and BANK_DATA_COLLECTED, these are optional/ignored
                const isSpecialEvent = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';

                if (!isSpecialEvent) {
                    // Check if it's a valid integer
                    if (value === '' || value === null) {
                        // Optional ? If required add error
                    } else if (!/^\d+$/.test(value)) {
                        error = 'Only numbers allowed'
                    }
                }
                break
            case 'escalationEmail':
                const isSpecialEventEmail = formState.eventCode === 'WAITING_SCREEN' || formState.eventCode === 'BANK_DATA_COLLECTED';
                if (!isSpecialEventEmail) {
                    if (formState.escalationRequired && !value) {
                        error = 'Required if escalation is enabled'
                    } else if (value) {
                        const emails = value.split(',').map(email => email.trim()).filter(email => email !== '');
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        const invalidEmails = emails.filter(email => !emailRegex.test(email));
                        if (invalidEmails.length > 0) {
                            error = 'One or more invalid email formats';
                        }
                    }
                }
                break
            case 'escalationRequired':
                // Dependent validations handled in specific fields or form validation
                break
            case 'isActive':
                // Dependent validations handled in specific fields or form validation
                break
            default:
                break
        }

        if (error) {
            errors[field] = error
        } else {
            delete errors[field]
        }
        return errors
    }

    validateForm = (details) => {
        let isValid = true
        let errors = {}

        // Basic required checks for enable/disable save
        if (!details.eventName || details.eventName.length < 5) isValid = false
        if (!details.eventCode) isValid = false
        // ... add other critical checks

        // A simpler way: Check if any errors exist in state after complete validation, 
        // OR run full validation on every change. 
        // Let's run full validation for isValid flag

        if (!details.eventName || details.eventName.length < 5) errors.eventName = 'Min 5 chars'
        if (!details.eventCode) errors.eventCode = 'Required'
        if (details.eventCode !== 'PAN_AWAITED') {
            if (!details.whatsappTemplateName || details.whatsappTemplateName.length < 5) errors.whatsappTemplateName = 'Min 5 chars'
        }

        const isSpecialEvent = details.eventCode === 'WAITING_SCREEN' || details.eventCode === 'BANK_DATA_COLLECTED';

        if (!isSpecialEvent) {
            if (!details.messageBodyText || details.messageBodyText.length < 5) errors.messageBodyText = 'Min 5 chars'
        }

        const isPanAwaited = details.eventCode === 'PAN_AWAITED';

        if (!isSpecialEvent) {
            if (!isPanAwaited) {
                if (!details.whatsappFrequencyDays) errors.whatsappFrequencyDays = 'Required'
                if (!details.maxWhatsappCount) errors.maxWhatsappCount = 'Required'
            }
            if (!details.emailFrequencyDays) errors.emailFrequencyDays = 'Required'
            if (!details.maxEmailCount) errors.maxEmailCount = 'Required'
            if (details.escalationRequired && !details.escalationAfterReminders) errors.escalationAfterReminders = 'Required'
            if (details.escalationRequired && !details.escalationEmail) {
                errors.escalationEmail = 'Required'
            } else if (details.escalationEmail) {
                const emails = details.escalationEmail.split(',').map(email => email.trim()).filter(email => email !== '');
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const invalidEmails = emails.filter(email => !emailRegex.test(email));
                if (invalidEmails.length > 0) {
                    errors.escalationEmail = 'Invalid format';
                }
            }
            if (details.isActive && !details.coolOffPeriodMin) errors.coolOffPeriodMin = 'Required'
        }

        if (Object.keys(errors).length > 0) isValid = false

        this.setState({ isFormValid: isValid })
        return isValid
    }

    handleInputChange = (field, value) => {
        // Strict number check for inputs preventing non-digits at SF level too if needed, 
        // but UI onKeyDown is better for UX.
        // Here we validate.

        let newDetails = {
            ...this.state.eventDetails,
            [field]: value
        }

        let errors = this.validateField(field, value, newDetails)

        // Update state
        this.setState({
            eventDetails: newDetails,
            errors: errors
        }, () => {
            this.validateForm(newDetails)
        })
    }

    handleSubmit = () => {
        this.setState({ submitting: true, submitError: null })
        let context = this.props.context
        let payload = this.state.eventDetails

        RestApiUtils.post(context, '/api/notify-event-configurations', this.handleSubmitCallback, payload)
    }

    handleSubmitCallback = (response) => {
        // Logic same as Edit, but checking for success
        if (response && (response.success || response.eventCode)) {
            this.setState({ submitting: false })
            this.props.history.push('/su/onboarding-events')
        } else if (response && response.errorList) {
            this.setState({ submitting: false, submitError: response.errorList[0].message })
        } else {
            this.setState({ submitting: false, submitError: 'Creation failed. Please try again.' })
        }
    }

    onCancel = () => {
        this.props.history.goBack()
    }

    render() {
        return (
            <OnboardingEventConfigAddPageUI
                context={this.props.context}
                eventDetails={this.state.eventDetails}
                loading={this.state.loading}
                errorList={this.state.errorList}
                submitting={this.state.submitting}
                submitError={this.state.submitError}
                onInputChange={this.handleInputChange}
                onSubmit={this.handleSubmit}
                onCancel={this.onCancel}
                errors={this.state.errors}
                isFormValid={this.state.isFormValid}
            />
        )
    }
}

export default withRouter(OnboardingEventConfigAddPageSF)
